import { FileSystemUploadType, uploadAsync } from "expo-file-system/legacy";
import { Platform } from "react-native";
import { captureException } from "@utils/captureException";
import type { DataSession } from "../../../data/core/session";

export const uploadImage = async (
  data: DataSession,
  {
    uri,
    contentType,
  }: {
    uri: string;
    contentType?: string | null;
  },
) => {
  try {
    const { signedUrl, imageUrl } =
      await data.api.user.getImageUploadUrl.mutate();
    const headers = contentType ? { "Content-Type": contentType } : undefined;

    if (Platform.OS === "web") {
      const fileResponse = await fetch(uri);
      if (!fileResponse.ok) {
        throw new Error(
          `Could not read the selected image (${fileResponse.status})`,
        );
      }

      const uploadResponse = await fetch(signedUrl, {
        method: "PUT",
        headers,
        body: await fileResponse.blob(),
      });
      if (!uploadResponse.ok) {
        throw new Error(`Image upload failed (${uploadResponse.status})`);
      }
    } else {
      const uploadResult = await uploadAsync(signedUrl, uri, {
        httpMethod: "PUT",
        uploadType: FileSystemUploadType.BINARY_CONTENT,
        headers,
      });
      if (uploadResult.status < 200 || uploadResult.status >= 300) {
        throw new Error(
          `Image upload failed (${uploadResult.status}): ${uploadResult.body}`,
        );
      }
    }

    return imageUrl;
  } catch (error) {
    captureException(error, {
      channel: "error",
      area: "profile",
      operation: "upload-profile-image",
    });
    throw error;
  }
};
